import { Layer } from "@hscmap/stellar-globe";
import Vue, { CreateElement } from "vue";
import Component, { mixins } from "vue-class-component";
import { Inject } from "vue-property-decorator";
import { GlobeComponentType } from "./Globe/script";
import { KEYS } from "./key";

// @ts-ignore
@mixins
@Component
export class LayerComponentBase<L extends Layer> extends Vue {
  @Inject(KEYS.GlobeComponent)
  globeComponent!: GlobeComponentType

  layer!: L

  get globe() {
    return this.globeComponent.globe
  }

  mounted() {
    console.assert(!!(this as any).newLayer, `${this.constructor.name} must have newLayer(): => L extends Layer`)
    this.refreshLayer()
  }

  beforeDestroy() {
    l2c.delete(this.layer)
    this.globeComponent.globe.removeLayer(this.layer)
  }

  protected refreshLayer() {
    if (this.layer) {
      l2c.delete(this.layer)
      this.globeComponent.globe.removeLayer(this.layer)
    }
    const layer = (this as any).newLayer()
    this.layer = layer
    l2c.set(this.layer, this.$el as HTMLElement)
    this.globeComponent.globe.addLayer(this.layer)
  }

  render(h: CreateElement) {
    return h('div', this.$slots.default)
  }
}

const l2c = new Map<Layer, HTMLElement>()

export function compare(la: Layer, lb: Layer) {
  const ea = l2c.get(la)
  const eb = l2c.get(lb)

  if (ea === eb) {
    return 0
  }

  if (ea === undefined) {
    return +1
  } else {
    if (eb === undefined) {
      return -1
    } else {
      const ra = route(ea)
      const rb = route(eb)
      const ci = common(ra, rb)
      return ra[ci + 1].idx - rb[ci + 1].idx
    }
  }
}

interface IRoute {
  el: Element,
  idx: number,
}

function route(e0: Element) {
  const a: Element[] = []
  let e: Element | null = e0
  while (e) {
    a.push(e)
    e = e.parentElement
  }
  if (a.length === 0) {
    console.error(e0)
    throw new Error('a.length == 0')
  }
  a.reverse()
  const r: IRoute[] = []
  for (let i = 0; i < a.length - 1; ++i) {
    const el = a[i]
    const idx = Array.from(el.children).indexOf(a[i + 1])
    r.push({ el, idx })
  }
  return r
}

function common(r1: IRoute[], r2: IRoute[]) {
  const l = Math.min(r1.length, r2.length)
  for (let i = 0; i < l; ++i) {
    const p1 = r1[i]
    const p2 = r2[i]
    if (!(p1.el === p2.el && p1.idx === p2.idx)) {
      return i - 1
    }
  }
  return -1
}
